import { useAccount } from '@/hooks/useAccount';
import { SubscriptionTier } from '@/actions/dtos/subscription';

export const useSelectText = () => {
  const { currentTier } = useAccount();
  const isAbleToSelectText = currentTier === SubscriptionTier.ULTIMATE || currentTier === SubscriptionTier.PROFESSIONAL;

  return `${isAbleToSelectText ? '' : 'select-none'}`;
};
